<script>
	import { createEventDispatcher } from 'svelte';
	import { Icon } from '@ctm/icons';
	import { TickCircle, Information, Close } from '@ctm/icons/interface';
	import { fade } from 'svelte/transition';

	const dispatch = createEventDispatcher();

	/** @type {"success" | "info"} */
	export let type = 'success';

	/** @type {"banner" | "modal"} */
	export let displayType = 'banner';

	/** @type {boolean} */
	export let dismissable = false;

	/** @type {string} */
	export let message = 'Update has been successfully posted.';

	function onClose() {
		dispatch('close');
	}
</script>

<div class={`notifcation ${type} ${displayType}`} transition:fade|global>
	{#if dismissable}
		<button class="close" name="notification-close-button" on:click={onClose}>
			<Icon icon={Close} size="sm" />
		</button>
	{/if}
	<i class="icon">
		{#if type === 'info'}
			<Icon icon={Information} size="md" />
		{:else}
			<Icon icon={TickCircle} size="md" />
		{/if}
	</i>
	<div class="message">{message}</div>
</div>

<style>
	.notifcation {
		display: flex;
		padding: 0 8px;
		justify-content: center;
		align-items: center;
		height: 40px;
		position: fixed;
		left: 50%;
		z-index: 999;
		transform: translate(-50%, 0);
		border-radius: 4px;
		background-color: #ffffff;
		box-shadow:
			0 4px 8px 0 rgba(33, 43, 54, 0.16),
			0 8px 24px 0 rgba(33, 43, 54, 0.24);
		top: calc(var(--page-header-height) + 16px);
	}

	.notifcation.modal {
		padding: 18px 60px 22px 22px;
		height: auto;
		border-radius: 8px;
		box-shadow:
			0px 8px 60px 0px rgba(32, 43, 51, 0.32),
			0px 12px 24px -4px rgba(32, 43, 51, 0.24);
	}

	.close {
		cursor: pointer;
		position: absolute;
		top: 8px;
		right: 8px;
		padding: 0;
	}

	.close :global(svg) {
		color: var(--n7);
	}

	.message {
		color: var(--content-default);
		font-size: 16px;
		line-height: 24px;
	}

	i {
		width: 21px;
		height: 21px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 10px 0 0;
	}

	.success .icon :global(svg) {
		color: var(--green-6);
	}

	.notifcation.modal i {
		margin: 0 40px 0 0;
	}
</style>
